var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app_warp"},[_c('router-view'),_c('tabbar-top'),_c('tabbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }